import React, {useState, useEffect} from 'react';
import { Row, Col, List, Card } from 'antd';

const ListImageProductView = (props) => {
    const { images } = props
    const [current, setCurrent]=useState(null)

    useEffect(() => {
        setCurrent(images[0])
    }, [images])

    console.log(current)
    return (
        <Row type="flex" justify="center" align="middle">
            <Col lg={24} md={24} xs={24} className="cardCurrentImage" >
                {current && <img src={current.image_product}  alt={current.id}/>}
            </Col>
            <Col lg={24} md={24} xs={24} style={{paddingRight:10}}>
                <List
                 pagination={{
                    pageSize: 3,
                  }}
                    grid={{
                        gutter: 16,
                        xs: 3,
                        sm: 3,
                        md: 2,
                        lg: 4,
                        xl: 4,
                        xxl: 3
                    }}
                    dataSource={images}
                    renderItem={item => (
                        <List.Item onClick={()=>setCurrent(item)} > 
                            <Card className="CardListImage" >
                                <img src={item.image_product}  alt={item.id} />
                            </Card>
                        </List.Item>
                    )}
                />
            </Col>
        </Row>
    );
};

export default ListImageProductView;